import { adminAPI } from '../services/apiService';

// Cache for admin emails to avoid repeated API calls
let adminEmailsCache = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const getAdminEmails = async () => {
    // Check if cache is still valid
    if (adminEmailsCache && cacheTimestamp && (Date.now() - cacheTimestamp) < CACHE_DURATION) {
        return adminEmailsCache;
    }

    try {
        const response = await adminAPI.getAdmins();
        
        if (response.admins) {
            // Filter only active admins and extract emails
            const activeAdminEmails = response.admins
                .filter(admin => admin.is_active)
                .map(admin => admin.email);
            
            // Update cache
            adminEmailsCache = activeAdminEmails;
            cacheTimestamp = Date.now();
            
            return activeAdminEmails;
        }
        return [];
    } catch (error) {
        console.error('Error fetching admin emails:', error);
        // Return cached data if available, otherwise empty array
        return adminEmailsCache || [];
    }
};

export const checkUserRole = async (userEmail) => {
    try {
        const adminEmails = await getAdminEmails();
        const normalizedAdminEmails = adminEmails.map(email => email.trim().toLowerCase());
        const normalizedUserEmail = userEmail.trim().toLowerCase();

        const isAdmin = normalizedAdminEmails.includes(normalizedUserEmail);
        // Store the role in sessionStorage
        sessionStorage.setItem('userRole', isAdmin ? 'admin' : 'user');
        return isAdmin;
    } catch (error) {
        console.error('Error checking user role:', error);
        return false;
    }
};

// Function to clear cache when admins are updated
export const clearAdminCache = () => {
    adminEmailsCache = null;
    cacheTimestamp = null;
};

export const getUserRole = () => {
    return sessionStorage.getItem('userRole') || 'user';
};
